var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 0 1 6.32 12.905l3.39 3.39a1 1 0 0 1-1.414 1.415l-3.391-3.39A8 8 0 1 1 8 0m0 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2"
})));
export default SvgIconSearch;